import { render, staticRenderFns } from "./tableCopyBtn.vue?vue&type=template&id=0c14d5ef&scoped=true&"
import script from "./tableCopyBtn.vue?vue&type=script&lang=js&"
export * from "./tableCopyBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c14d5ef",
  null
  
)

export default component.exports